import axiosInstance from "../../config/axiosInstance";
import { onLoadFailure, onLoadRequest, onLoadSuccess } from "../reducers/MainReducer";



/////////////////////////////////////////////////
export const getUsers = () => async (dispatch) => {
  try {
    dispatch(onLoadRequest());
    const data = await axiosInstance.get(`/api/admin/get/allusers`);
  
    dispatch(onLoadSuccess(data?.data?.users));
  } catch (error) {
    dispatch(onLoadFailure(error.message));
  }
};

export const getAllPlans = () => async (dispatch) => {
  try {
    dispatch(onLoadRequest());
    const data  = await axiosInstance.get(`/api/admin/get/allplans`);
    dispatch(onLoadSuccess(data?.data?.plans));
  } catch (error) {
    dispatch(onLoadFailure(error.message));
  }
};
export const getAllFranchaise = () => async (dispatch) => {
  try {
    dispatch(onLoadRequest());
    const { data } = await axiosInstance.get(`/api/admin/get/getallfranchaise`);
    dispatch(onLoadSuccess(data?.franchise));
  } catch (error) {
    dispatch(onLoadFailure(error.message));
  }
};
export const getAllDealership = () => async (dispatch) => {
  try {
    dispatch(onLoadRequest());
   const data  = await axiosInstance.get(`/api/admin/get/getalldealership`);
    dispatch(onLoadSuccess(data?.data?.dealership));
  } catch (error) {
    dispatch(onLoadFailure(error.message));
  }
};
export const getAllSaleYourBusiness = () => async (dispatch) => {
  try {
    dispatch(onLoadRequest());
    const { data } = await axiosInstance.get(
      `/api/admin/get/getallsellyourbusiness`
    );
    dispatch(onLoadSuccess(data?.sellYourBusiness));
  } catch (error) {
    dispatch(onLoadFailure(error.message));
  }
};
export const getAllInvestor = () => async (dispatch) => {
  try {
      dispatch(onLoadRequest());
      const { data } = await axiosInstance.get(`/api/admin/get/getallInvestor`);
      dispatch(onLoadSuccess(data?.investor));
    
  } catch (error) {
      dispatch(onLoadFailure(error.message)); 
  }
}
export const getAllContactus = () => async (dispatch) => {
  try {
      dispatch(onLoadRequest());
      const { data } = await axiosInstance.get(`/api/admin/get/getallcontacts`);
      dispatch(onLoadSuccess(data?.data));
    
  } catch (error) {
      dispatch(onLoadFailure(error.message)); 
  }
}
///////////////////updateroutes



export const updateDealership =async  ({id,formData})  => {
  try {
    
   
 
    const data = await axiosInstance.put(
      `/api/admin/update/dealership/${id}`,
      formData
    );
     return data;
  } catch (error) {
    return error;
  }
};
export const updateSellYourBusiness = async ({ id,
  
   businessName,
        gstNumber         ,entityType ,
        businessCategory ,
        businessPhotoUrl ,
        logoPhotoUrl ,

        address ,
        street ,
        city ,
        country ,
        state ,
        postalCode ,
        businessOverview ,
        businessDetails,
        
        
        typeOfBusinessPremises ,
        areaSqFt ,
        reasonToSell ,
        quotedValue ,


        annualSales ,
        grossIncome ,
        ebitda,
        rentals,
        noOfEmployees,
        payment_status ,
        acceptanceOfTermsAndConditions,
        agreementToPrivacyPolicy,


}) => {
  let formdata = new FormData();
  formdata.append('businessName', businessName);
  formdata.append("gstNumber", gstNumber);
  formdata.append("entityType", entityType);
  formdata.append("businessCategory", businessCategory);
  formdata.append("businessPhotoUrl", businessPhotoUrl);
  formdata.append("logoPhotoUrl", logoPhotoUrl);
  formdata.append("address", address);
  formdata.append("street", street);
  formdata.append("city", city);
  formdata.append("country", country);
  formdata.append("state", state);
  formdata.append("postalCode", postalCode);
  formdata.append("businessOverview", businessOverview);
  formdata.append("businessDetails", businessDetails);
  formdata.append("typeOfBusinessPremises", typeOfBusinessPremises);
  formdata.append("areaSqFt", areaSqFt);
  formdata.append("quotedValue", quotedValue);
  formdata.append("annualSales", annualSales);
  formdata.append("ebitda", ebitda);
  formdata.append("rentals", rentals);
  formdata.append("noOfEmployees", noOfEmployees);
  formdata.append("payment_status", payment_status);
  formdata.append(
    "acceptanceOfTermsAndConditions",
    acceptanceOfTermsAndConditions
  );
  formdata.append("agreementToPrivacyPolicy", agreementToPrivacyPolicy);


  
 
   
    const data = await axiosInstance.put(
      `/api/admin/update/sellyourbusiness/${id}`,
      formdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }
    );
     return data;

};

//delete
export const deleteFranchaise = async (id) => {

  const data = await axiosInstance.delete(`/api/admin/delete/franchise/${id}`);

    return data;
 
};
export const deleteDealership = async (id) => {
  try {
    const data = await axiosInstance.delete(
      `/api/admin/delete/dealership/${id}`);
    return data;
  } catch (error) {
    return error;
  }
};
export const deleteSellYourBusiness = async (id) => {
  try {
    const data = await axiosInstance.delete(
      `/api/admin/delete/sellyourbusiness/${id}`
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const deleteUser = async (id) => {
  try {
    const data = await axiosInstance.delete(`/api/admin/delete/user/${id}`);
    return data;
    
  }
  catch (e) {
    console.log('the error is', e);
    return e;
  }
}
export const deletePlan = async (id) => {
  try {
    const data = await axiosInstance.delete(`/api/admin/delete/plan/${id}`);
    return data;
    
  }
  catch (e) {
    console.log('the error is', e);
    return e;
  }
}



export const approveFranchiseRequest = async (status,id) => {
  const response =await  axiosInstance.post(`/api/admin/approve/franchise/${id}`, {
    status
  });
  return response;
};
export const approveDealershipRequest = async (status,id) => {
  const response =await  axiosInstance.post(`/api/admin/approve/dealership/${id}`, {
    status
  });
  console.log(response,'the respons is')
  return response;
};
export const approveSellYourBusinessRequest = async (status,id) => {
  const response = await axiosInstance.post(
    `/api/admin/approve/sellyourbusiness/${id}`,
    {
      status,
    }
  );
  return response;
};
export const approveInvestRequest = async (status, id) => {
  console.log('the status',status,id)
  const response = axiosInstance.post(`/api/admin/approve/investor/${id}`, {
    status
  });
  return response;
};